import { adminApi } from "./adminService";
import { aiAgentsApi } from "./aiAgents";
import { analyticsApi } from "./analyticsService";
import { bffApi } from "./bffService";
import { claimsApi } from "./claimsService";
import { docGenApi } from "./docGenService";
import { emailServiceApi } from "./emailService";
import { exchangeApi } from "./exchangeService";
import { filesApi } from "./filesService";
import { generatedDocumentsApi } from "./generatedDocumentsService";
import { ingestApi } from "./ingestService";
import { materializeApi } from "./materializeService";
import { notesApi } from "./notesService";
import { reportApi } from "./reportService";
import { reportsV3Api } from "./reportsV3Service";
import { researchApi } from "./researchService";
import { sovApi } from "./sovService";
import { staticDataApi } from "./staticDataService";
import { submissionsApi } from "./submissionsService";
import { suggestionsApi } from "./suggestionService";
import { tablesApi } from "./tablesService";
import { transferApi } from "./transferService";
import { userServiceApi } from "./userService";

const allApis = [
  adminApi,
  aiAgentsApi,
  analyticsApi,
  bffApi,
  claimsApi,
  docGenApi,
  emailServiceApi,
  exchangeApi,
  filesApi,
  generatedDocumentsApi,
  tablesApi,
  ingestApi,
  materializeApi,
  notesApi,
  researchApi,
  reportApi,
  reportsV3Api,
  sovApi,
  staticDataApi,
  submissionsApi,
  transferApi,
  userServiceApi,
  suggestionsApi,
];

export default allApis;
